import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: 'AIzaSyBf4BndRMicxE9J4tIdvBfXZD7IRRR1tYo',
    authDomain: 'jobseeqr.co',
    projectId: 'jobseeqr',
    databaseURL: 'https://jobseeqr.firebaseio.com',
    storageBucket: 'jobseeqr.appspot.com',
    messagingSenderId: '435586021357',
    appId: '1:435586021357:web:5a192f0a7fd6100a71d9e4'
  };

// Validate Config
if (!firebaseConfig.apiKey || firebaseConfig.apiKey === 'your_api_key') {
  console.error("Firebase Configuration Missing! Please update .env file with your Firebase credentials.");
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);
export default app;
